<template>
  <div>
    <!-- Page Content -->
    <div class="content">
      <!-- Full Table -->
      <base-block rounded title="Test Question Details">
        <b-table-simple responsive bordered striped table-class="table-vcenter">
          <b-thead>
            <b-tr>
              <b-th class="text-center">S.NO</b-th>
              <b-th class="text-center">Parent Topic</b-th>
              <b-th class="text-center">Question Count</b-th>
              <b-th class="text-center">Duration</b-th>
              <b-th class="text-center" v-if="type == 'default'">Action</b-th>
            </b-tr>
          </b-thead>
          <b-tbody>
            <b-tr v-for="(question, index) in questions" :key="index">
              <b-td class="text-center">
                {{ index + 1 }}
              </b-td>
              <b-td class="text-center">{{ question.topic_name }}</b-td>
              <b-td class="text-center">{{ question.no_of_questions }}</b-td>
              <b-td class="text-center">{{ question.duration }}</b-td>
              <b-td class="text-center" v-if="type == 'default'">
                <b-button
                  size="sm"
                  variant="alt-primary"
                  v-b-modal.modal-1
                  @click="getQuestions(question.id)"
                >
                  <i class="fa fa-fw fa-eye"></i>
                </b-button>
              </b-td>
            </b-tr>
          </b-tbody>
        </b-table-simple>

        <!-- modal -->

        <b-modal
          id="modal-1"
          title="Questions"
          size="xl"
          ref="modalone"
          no-close-on-esc
          no-close-on-backdrop
          hide-footer
          @close="questionData = []"
        >
          <!-- legends -->
          <div class="col-md-12" v-if="questionData != ''">
            <dl class="float-right">
              <dt class="green"></dt>
              <dd>Fillups</dd>

              <dt class="blue"></dt>
              <dd>Group</dd>

              <dt class="grey"></dt>
              <dd>MCQ</dd>
            </dl>
            <br />
          </div>
          <!-- Questions list -->

          <div>
            <br />
            <b-list-group
              class="list-group"
              v-for="(question, index) in questionData"
              :key="index"
            >
              <div
                v-for="(quest, index1) in questionData[index].questions"
                :key="index1"
              >
                <b-list-group-item
                  :class="
                    questionData[index].questions[index1].question_type ==
                    'fill_in_blank'
                      ? 'border-warning mb-1'
                      : questionData[index].questions[index1].group_question !=
                        null
                      ? 'border-primary mb-1'
                      : 'border-dark mb-1'
                  "
                  v-html="`${questionData[index].questions[index1].question}`"
                >
                </b-list-group-item>
              </div>
            </b-list-group>
          </div>
          <div class="text-right mt-3" v-if="questionData.length > 0">
            <b-button variant="success" @click="Ok()">Ok</b-button>
          </div>
        </b-modal>
      </base-block>
    </div>
  </div>
</template> 

<script>
import axios from "axios";
export default {
  data() {
    return {
      type: "",
      questions: {},
      questionData: [],
    };
  },

  mounted() {
    this.getTests();
  },
  methods: {
    Ok() {
      this.$refs.modalone.hide();
      this.questionData = [];
    },
    async getTests() {
      await axios
        .get(
          `${this.$store.getters.baseUrl}/mock-test/detail/${this.$route.params.id} `,
          {
            headers: { Authorization: `Bearer ${this.$store.getters.token}` },
          }
        )
        .then((response) => {
          console.log(response);
          if (response.data.status == "success") {
            this.type = response.data.test_detail.test_type;
            this.questions = response.data.topic_detail;
          } else {
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch((error) => {
          console.log(error);
          this.$swal("Error", error.response.data.message, "error");
        });
    },
    async getQuestions(id) {
      await axios
        .get(`${this.$store.getters.baseUrl}/mock-tests/questions/${id}`, {
          headers: { Authorization: `Bearer ${this.$store.getters.token}` },
        })
        .then((response) => {
          console.log(response);
          if (response.data.status == "success") {
            this.questionData = response.data.topic_questions;
          } else {
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch((error) => {
          console.log(error);
          this.$swal("Error", error.response.data.message, "error");
        });
      if ("MathJax" in window) {
        this.$nextTick(function () {
          window.MathJax.Hub.Queue(["Typeset", window.MathJax.Hub], () =>
            console.log("done")
          );
        });
      }
    },
  },
};
</script>

<style scoped>
dl dt {
  display: inline-block;
  width: 20px;
  height: 20px;
  vertical-align: middle;
}
dl dd {
  display: inline-block;
  margin: 0px 10px;
  padding-bottom: 0;
  vertical-align: middle;
}
dl dt.green {
  background: #e5ae67;
}
dl dt.grey {
  background: #343a40;
}
dl dt.blue {
  background: #5179d6;
}
</style>